export default __webpack_public_path__ + "04628ba5da883e41865087e33bce7a3a.svg";